import axios from 'axios'
import { 
    categoryListRequest,
    categoryListSuccess,
    categoryListFail,
    categoryDetailsRequest,
    categoryDetailsSuccess,
    categoryDetailsFail,
} from '../reducers/categoryReducers'

// Function to get CSRF token from cookie
const getCsrfToken = () => {
    const name = 'csrftoken';
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}

const createAPIinstance = () => {
    const csrfToken = getCsrfToken();
    return axios.create({
        baseURL: `${process.env.REACT_APP_BASE_API_URL}/api/categories`,
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': csrfToken
        },
        withCredentials: true
    })
}

export const listCategories = (status = 'all') => async (dispatch) => {
    try {
        dispatch(categoryListRequest())
        const api = createAPIinstance()
        const { data } = await api.get(`/?status=${status}`)
        
        // Extract the first category from results array
        const categories = data.results ? data.results[0] : data;
        
        dispatch(categoryListSuccess(categories))
    } catch (error) {
        dispatch(categoryListFail(
            error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message
        ))
    }
}

export const detailCategories = (id, status = 'all') => async (dispatch) => {
    try {
        dispatch(categoryDetailsRequest())
        const api = createAPIinstance()
        
        // Just use the ID directly without adding /categories/ prefix
        // since baseURL already includes /api/categories
        const endpoint = id === 'all' ? '/' : `/${id}`
        
        const { data } = await api.get(`${endpoint}?status=${status}`)
        
        // Extract the first category from results array if it exists
        const category = data.results ? data.results[0] : data;
        
        dispatch(categoryDetailsSuccess(category))
    } catch (error) {
        dispatch(categoryDetailsFail(
            error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message
        ))
    }
}
